import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { trackPageView } from "@/services/analytics";

export function NavigationBreadcrumbs() {
  const location = useLocation();

  useEffect(() => {
    Sentry.addBreadcrumb({
      category: "route",
      message: "Navigated",
      data: { pathname: location.pathname },
      level: "info",
    });

    const pageName =
      location.pathname === "/"
        ? "home"
        : location.pathname.replace(/^\//, "").replace(/\//g, "_");
    trackPageView(pageName);
  }, [location.pathname]);

  return null;
}
